// extracted by mini-css-extract-plugin
module.exports = {"button":"_3pUX5vdbAN0lJTQLmDYxPA","icon":"_3uZqLs6t1dYbdC9G9u5Qn3"};